import { useStaticQuery, graphql } from 'gatsby'

export default function useGetAllBuilderProducts(identifier) {
    const data = useStaticQuery(graphql`
        fragment Product on builder_MpcProductData{
            forceOnSale
            releaseDate
            releaseDateValue
            legacy
            featured
            image
            badge
            name
            sku
            url
            description
            shortDescription
            category
            worksWith
            tryItFree
            includes
            requires
            pimcoreProductionId
            pimcoreStagingId
        }
        query{
            allBuilderModels{
                l1: mpcProduct(offset: 0, limit: 100, options: { cachebust: true }){
                    id
                    data{
                        ...Product
                    }
                }
                l2: mpcProduct(offset: 100, limit: 100, options: { cachebust: true }){
                    id
                    data{
                        ...Product
                    }
                }
            }
        }
    `)

    const arr = [
        ...data.allBuilderModels.l1,
        ...data.allBuilderModels.l2,
    ]
        .map(({ id, data }) => ({ id, ...data }))
        .sort((a, b) => {
            const x = a?.data?.releaseDateValue
            const y = b?.data?.releaseDateValue

            if(!x && !y) return 0

            if(x && !y) return -1
            if(!x && y) return 1

            if(x > y) return -1
            if(x < y) return 1

            return 0
        })
    
    if(identifier) {
        return arr.find(({ id, sku }) => {
            const idMatch = id === identifier
            const skuMatch = sku === identifier
            return idMatch || skuMatch
        })
    }
    
    return arr
}
